import React from 'react';
import PropTypes from 'prop-types';

import { useClassName } from 'common/hooks';

import { ProfilePicture } from './ProfilePicture';

import './season-profiles.less';

export const SeasonProfiles = ({ profiles = [] }) => {
  const className = useClassName('SeasonProfiles');

  const uniqueProfiles = profiles.filter(
    (profile, index) =>
      profiles.findIndex((item) => item.ticketId === profile.ticketId) === index
  );

  if (!uniqueProfiles.length) return null;

  return (
    <div className={className('container')}>
      {uniqueProfiles.map((profile) => (
        <div key={profile.ticketId} className={className('profile')}>
          <ProfilePicture
            picture={profile.picture}
            name={profile.ticketHolder}
          />
          <span className={className('name')}>{profile.ticketHolder}</span>
        </div>
      ))}
    </div>
  );
};

SeasonProfiles.propTypes = {
  profiles: PropTypes.arrayOf(PropTypes.object),
};
